/*
 * OpenAI Ads click-reference (oppref) capture.
 *
 * WHY: the OpenAI pixel runs inside Shopify's sandboxed Web Pixels iframe and
 * is meant to remember `oppref` (the ad-click token) across pages via its own
 * cookie, but that sandbox is an isolated/opaque origin — the token was
 * measured at 0% match rate on every funnel event, including the very first
 * add-to-cart, which means it never survives past the landing page. This
 * script runs in the theme's own (non-sandboxed) context instead, so a cookie
 * it sets behaves normally, and it copies the token onto the cart as an
 * attribute — cart attributes ride along into the order automatically, which
 * is what a future server-side Conversions API call needs to read back.
 */
(function () {
  'use strict';

  var COOKIE_NAME = '_oppref';
  var COOKIE_MAX_AGE_DAYS = 30; // matches OpenAI's attribution window

  // Pure: pull `oppref` off a query string. Returns null if absent/blank.
  function readOprefFromSearch(search) {
    var value = new URLSearchParams(search || '').get('oppref');
    return value ? value : null;
  }

  // Pure: build a `Set-Cookie`-shaped string for document.cookie.
  function buildCookieString(name, value, maxAgeDays) {
    var maxAgeSeconds = maxAgeDays * 24 * 60 * 60;
    return name + '=' + encodeURIComponent(value) + '; max-age=' + maxAgeSeconds + '; path=/; SameSite=Lax';
  }

  // Impure: read a cookie by name from the live document.
  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  // Impure: attach oppref to the cart so it's present in the order's
  // note_attributes at checkout. Cart attribute writes merge by key, so this
  // never clobbers other attributes.
  function attachOprefToCart(oppref) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { oppref: oppref } }),
    }).catch(function () {
      /* tracking must never break the browsing/cart flow */
    });
  }

  function run() {
    var fromUrl = readOprefFromSearch(window.location.search);
    if (fromUrl) {
      document.cookie = buildCookieString(COOKIE_NAME, fromUrl, COOKIE_MAX_AGE_DAYS);
    }

    var oppref = fromUrl || readCookie(COOKIE_NAME);
    if (oppref) {
      attachOprefToCart(oppref);
    }
  }

  var api = {
    readOprefFromSearch: readOprefFromSearch,
    buildCookieString: buildCookieString,
  };

  if (typeof document !== 'undefined' && document.addEventListener) {
    run();
    window.OprefCapture = api;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})();
